import Flickity from 'flickity';

export default {
  init($element) {
  },
  finalize($element) {
    function updateCaption() {
      const currentCaption = $element.find('.full-width-gallery-carousel .carousel-cell.is-selected .image-item').data('caption');

      if (!currentCaption) {
        $element.find('.caption-wrap').addClass('d-none');
      } else {
        $element.find('.caption-wrap').removeClass('d-none');
        $element.find('.caption-wrap .image-item-caption').html(currentCaption);
      }
    }

    if ($element.find('.full-width-gallery-carousel')) {
      const fullWidthGalleryCarousel = new Flickity($element.find('.full-width-gallery-carousel').get()[0], {
        adaptiveHeight: true,
        autoPlay: false,
        prevNextButtons: false,
        pageDots: false,
        contain: true,
        on: {
          ready: function() {
            window.dispatchEvent(new Event('resize')); // Quickfix for sizing issue
            updateCaption();
          },
          change: function() {
            $element.find('.gallery-index .index-a').html(String(fullWidthGalleryCarousel.selectedIndex + 1));
            updateCaption();
          },
        },
      });
      
      // Scroll buttons
      $element.find('.gallery-slide-arrow-prev').on('click', function() {
        fullWidthGalleryCarousel.previous();
      });
      
      $element.find('.gallery-slide-arrow-next').on('click', function(i) {
        fullWidthGalleryCarousel.next();
      });
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/shared/fullWidthGallery.js